module.exports = __webpack_public_path__ + "static/visualizer2-5047057651887ae447aa5c5ea8cd3c70.jpg";